export interface ITripRequestLogCountResponse {
    total: number;
}
